import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzSelectComponent } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-creditable-select',
  templateUrl: './creditable-select.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CreditableSelectComponent),
      multi: true
    }
  ]
})
export class CreditableSelectComponent implements ControlValueAccessor {

  
  @ViewChild('selector') selector?: NzSelectComponent;
  enterEvent = false;
  mouseEvent = false;

  @Input() class: string = '';
  @Input() value: any;
  @Input() allowEdit = true;
  @Input() public disabled = false;
  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }
  @Input() borderless = false;
  @Input() placeholder = '';

  @Output() readonly blur = new EventEmitter();

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  valueChanged(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onBlur(e: any) {
    this.blur.emit(e);
  }

  handleClick(event: MouseEvent): void {
    this.mouseEvent = true;
  }

    handleKeyDown(event: KeyboardEvent): void {
      const arrowKeys = ['ArrowLeft', 'ArrowRight','Escape'];
       
      // when current position in select component, want to move the left right column, close the option list
      if (arrowKeys.includes(event.key)|| (event.key === 'Enter' && event.ctrlKey) || event.ctrlKey) {
        if(this.selector?.nzOpen){
          this.selector.nzOpen = false;
        }
        /**
         * To detect the option list just opened using enter key or event
         * Default action was using ArrowDown to open the option list, Avoid it
         */
        if(this.enterEvent) this.enterEvent = false;
        if(this.mouseEvent) this.mouseEvent = false;
      }

      switch (event.key) {
        case 'ArrowDown':  
          // if not open by enter key or mouse, did not open the option list
          // default is using arrow down to open the option list, avoid it
          if(this.selector)
            if(!this.enterEvent && !this.mouseEvent){
              this.selector.nzOpen = false;
            }
            else{
              event.stopPropagation();
            }
         break;

         // Make sure this component just listen the action from detail page
         case 'ArrowUp':
          if(this.selector)
            if(this.selector.nzOpen)
              event.stopPropagation();
         break;

         case 'Enter':
          /**
           * every time press enter key will reverse the boolean value, default it is false
           * to make sure the timing when customer select component selected value
           * that time event = false to make sure process sequence
           */
          if(!this.enterEvent) this.enterEvent = true;
          else this.enterEvent = false;

          /**
           * To double comfirm the option list was closed
           * If Remove below, will happen one situation, after customer select component selected value,
           * and move to next column, the option list will open again
           */
          if (!this.selector?.nzOpen) {
            if(this.selector)
              this.selector.nzOpen = false;
          }
          break;
          
          default:
            break;
      }

    }
}
